import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import { createEditor } from 'slate';
import { Slate, Editable, withReact } from 'slate-react';
import { RichTextEditorElement } from './RichTextEditor_Element';
import { Leaf } from './RichTextEditor_Leaf';
export const RichTextViewer = (param)=>{
    let { value, testId } = param;
    const editor = useMemo(()=>withReact(createEditor()), []);
    const renderElement = useCallback((props)=>{
        return /*#__PURE__*/ _jsx(RichTextEditorElement, _object_spread({}, props));
    }, []);
    const renderLeaf = useCallback((props)=>{
        return /*#__PURE__*/ _jsx(Leaf, _object_spread({}, props));
    }, []);
    return /*#__PURE__*/ _jsx(Slate, {
        editor: editor,
        value: value,
        onChange: ()=>{},
        children: /*#__PURE__*/ _jsx(Editable, {
            readOnly: true,
            renderLeaf: renderLeaf,
            renderElement: renderElement,
            "data-testid": testId
        })
    });
};
